import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { forkJoin, Observable, throwError, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpInterceptor,
  HttpParams,
  HttpResponse,
  HttpHandler,
  HttpErrorResponse,
  HttpEventType,
  // tslint:disable-next-line: import-spacing
} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DadosService {

  constructor(private HttpClient: HttpClient) {

    //   this.montaSaudeUsuario('codusuario')
  }


  getVacinas(): Observable<any> {
    let configUrl = environment.apiUrl + '/ListVacinas';
    return this.HttpClient.get(configUrl)
  }

  salvaVacinaUser(e): Observable<any> {
    let configUrl = environment.apiUrl + '/saveUserVacinado';
    return this.HttpClient.post(configUrl, e);
  }
  updateVacinaUser(e): Observable<any> {
    console.log(e)
    for (var value of e.values()) {
      console.log(value); 
   }
    let configUrl = environment.apiUrl + '/updateVacinaUsuario';
    return this.HttpClient.put(configUrl, e);
  }
  deleteVacinaUsuario(e): Observable<any> {
    let params = new HttpParams().set('id', e);
    let configUrl = environment.apiUrl + '/deleteVacinaUsuario';
    return this.HttpClient.delete(configUrl, { params: params });
  }
  getVacinasUsuario(cdmatricula): Observable<any> {
    let params = new HttpParams().set('cdmatricula', cdmatricula);
    let configUrl = environment.apiUrl + '/getVacinaUser';
    return this.HttpClient.get(configUrl, { params: params })
  }

  getExames(): Observable<any> {
    let configUrl = environment.apiUrl + '/ListExames';
    return this.HttpClient.get(configUrl)
  }

  salvaExameUser(e): Observable<any> {
    let configUrl = environment.apiUrl + '/saveExameUsuario';
    return this.HttpClient.post(configUrl, e);
  }
  updateExameUser(e): Observable<any> {
    console.log(e)
    for (var value of e.values()) {
      console.log(value); 
   }
    let configUrl = environment.apiUrl + '/updateExameUsuario';
    return this.HttpClient.put(configUrl, e);
  }
  deleteExameUsuario(e): Observable<any> {
    let params = new HttpParams().set('id', e);
    let configUrl = environment.apiUrl + '/deleteExameUsuario';
    return this.HttpClient.delete(configUrl, { params: params });
  }
  getExamesUsuario(cdmatricula): Observable<any> {
    let params = new HttpParams().set('cdmatricula', cdmatricula);
    let configUrl = environment.apiUrl + '/getExamesUser';
    return this.HttpClient.get(configUrl, { params: params })
  }

  salvaFormUser(e): Observable<any> {
    let configUrl = environment.apiUrl + '/saveForm';
    return this.HttpClient.post(configUrl, e);
  }

  ListAllFrmRespUser(cdmatricula): Observable<any> {
    let params = new HttpParams().set('cdmatricula', cdmatricula);
    let formularios = this.HttpClient.get<any>(environment.apiUrl + '/ListAllFrmRespUser', { params: params })
    let perguntas = this.HttpClient.get<any>(environment.apiUrl + '/ListPerguntas')
    return forkJoin({ formularios, perguntas })
  }

  listaFormUsuario(cdmatricula): Observable<any> {
    // console.log(cdmatricula)
    let formsArray = []
    return this.ListAllFrmRespUser(cdmatricula).pipe(
      map((formsEperguntas) => {
        let formularios = formsEperguntas.formularios
        let perguntas = formsEperguntas.perguntas
        formularios.forEach(form => {
          let prePush: any = {}
          prePush.dataenvio = form.formulario.dataenvio;
          prePush.id_formulario = form.formulario.id_formulario
          prePush.perguntas = []
          perguntas.forEach(pergunta => {
            let respostas = form.respostas
            let respostasArray = []
            respostas.forEach(resp => {
              if (resp.codpergunta == pergunta.codpergunta) {
                if (resp.codresposta == "") {
                  if (resp.dt_resposta !== "") {
                    let dataF = moment(resp.dt_resposta).format('DD/MM/YYYY');
                    respostasArray.push(dataF)
                  }
                  if (resp.resposta_string !== "") {
                    respostasArray.push(resp.resposta_string)
                  }
                } else {
                  respostasArray.push(resp.ds_resposta)
                }
              }
            });

            prePush.perguntas.push({
              codpergunta: pergunta.codpergunta,
              pergunta: pergunta.ds_pergunta,
              respostas: respostasArray
            })

          });

          formsArray.push(prePush)
        });
        // console.log(formsArray)
        return formsArray

      }), catchError(error => {
        return throwError('Something went wrong!', error);
      })
    )

  }


}